import { cn } from '@bem-react/classname';

export const cnButton = cn('Button');
